import React from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";

/**
 * Shared create/edit dialog shell used by System and Tenant forms.
 */
const FormDialog = ({
  open,
  title,
  onClose,
  onSubmit,
  loading = false,
  disableSubmit = false,
  submitLabel = "Save",
  loadingLabel = "Saving...",
  cancelLabel = "Cancel",
  maxWidth = "sm",
  error = "",
  onClearError,
  children,
}) => {
  const handleSubmit = (event) => {
    event?.preventDefault?.();
    if (!loading && !disableSubmit) {
      onSubmit?.();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (loading) return;
        if (reason === "backdropClick") return;
        onClose?.();
      }}
      fullWidth
      maxWidth={maxWidth}
      disableEnforceFocus
    >
      <DialogTitle sx={{ pb: 1.5, pt: 2.5, px: 3 }}>{title}</DialogTitle>
      <DialogContent sx={{ px: 3, pt: 2, pb: 1.5, overflow: "visible" }}>
        {error ? (
          <Alert
            severity="error"
            sx={{ mb: 2 }}
            onClose={onClearError ? () => onClearError() : undefined}
          >
            {error}
          </Alert>
        ) : null}
        <Stack component="form" noValidate spacing={2.5} onSubmit={handleSubmit}>
          {children}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading || disableSubmit}
        >
          {loading ? loadingLabel : submitLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FormDialog;
